// SimpleListStore
import {defineStore} from 'pinia'
import {ref} from 'vue';
import {getObject, IResultAndError} from '../../lib/ChoiceApi'; 
import {popAlert,ModalStyles} from '../../lib/Notification';     

export interface ISimpleList {
    value: string,
    description: string,
    header?: string,
    warningMessage?: string
} 

export const useSimpleListStore = defineStore('SimpleListStore', () => { 
    const listResult = ref<Record<string,ISimpleList[]>>({});

    async function getSimpleWhereList(listName : string, whereClause : string) : Promise<void> {        
        const newWhereClause = whereClause.replace(/ /g, "__");
        await callSimpleList(listName,newWhereClause);
    }
    async function getSimpleLists(listNames : string[]) : Promise<void> {
        for (const name of listNames)
        {
            await callSimpleList(name);
        }
    }
    
    async function callSimpleList(listName: string, whereClause? : string) : Promise<void> {
        listResult.value[listName] = [];
        const returnResults = await retrieveSimpleList(listName,whereClause);
        if (!returnResults.success) {  
            await popAlert(returnResults.error?.error ?? "Unable to obtain list information.","Error",ModalStyles.danger);
            return;
        }
        listResult.value[listName] = returnResults.success; 
    }

    async function retrieveSimpleList(listName : string, whereClause? : string): Promise<IResultAndError<ISimpleList[]>>{  
        let returnErrorMessage = ""; 
        const url = `api/SimpleLists/Simple/GetSimpleList/${listName}/${whereClause}`;
        const responseObject = await getObject<ISimpleList[]>(url,(httResp, errorMessage) =>  { 
            returnErrorMessage = errorMessage ?? "Unable to obtain list information.";
        });
        if (responseObject)
            return {success: responseObject};
        else 
            return {error: {error: returnErrorMessage}}; 
    };
    return {listResult, getSimpleLists, getSimpleWhereList};
});

